module.exports = __webpack_public_path__ + "static/media/logo@2x.321fdbb0.png";